import React from 'react';
import { Text } from '@uhg-abyss/web/ui/Text';

type UniteUsPhoneNumbers = {
  is_primary?: boolean | null;
  phone_type?: string;
  country_code?: string;
  phone_number: string;
  extension?: any | null;
};

export type CboCardUniteUsNextStepsProps = {
  closestOfficeAddressText: string;
  closestOfficeEmail: string;
  closestOfficeWebsite: string;
  closestOfficePhone: string[] | UniteUsPhoneNumbers[];
};

export const CboCardUniteUsNextSteps = ({
  closestOfficeAddressText,
  closestOfficeEmail,
  closestOfficeWebsite,
  closestOfficePhone,
}: CboCardUniteUsNextStepsProps) => {
  const hasNextSteps =
    closestOfficeAddressText ||
    closestOfficeEmail ||
    closestOfficeWebsite ||
    (closestOfficePhone && closestOfficePhone.length > 0);

  return (
    <div>
      <Text color="black" fontWeight="bold" fontSize="md">
        Next steps:
      </Text>
      {hasNextSteps ? (
        <ul>
          {closestOfficeAddressText && (
            <li>
              <Text color="black" fontWeight="regular" fontSize="md">
                Go to {closestOfficeAddressText} to schedule an appointment.
              </Text>
            </li>
          )}
          {closestOfficeEmail && (
            <li>
              <span>
                Write an email to{' '}
                <a href={`mailto:${closestOfficeEmail}`}>
                  {closestOfficeEmail}
                </a>
                {' '}to schedule an appointment.
              </span>
            </li>
          )}
          {closestOfficeWebsite && (
            <li>
              <span>
                Go to the website{' '}
                <a href={closestOfficeWebsite}>{closestOfficeWebsite}</a> to get
                more info.
              </span>
            </li>
          )}
          {closestOfficePhone && closestOfficePhone.length > 0 && (
            <li>
              <span>
                Call{' '}
                {Array.isArray(closestOfficePhone)
                  ? closestOfficePhone
                      .map((phone) => {
                        return phone.phone_number;
                      })
                      .join(', ')
                  : closestOfficePhone}{' '}
                to get services.
              </span>
            </li>
          )}
        </ul>
      ) : (
        <div>No next steps</div>
      )}
    </div>
  );
};
